import React, { useState, useRef } from 'react';
import { Modal, Button, Checkbox, Pagination, Spin, Space, Input } from 'antd';
// import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { CustomListItem, IconSearch } from './style';
import { useCustomListItems } from './hooks/useCustomListItems';
import { useCheckableItems } from './hooks/useCheckableListItems';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { FormWrapper } from '../../../formWrapper/form-wrapper';
import { CustomListsService } from '../../../../services/customListService';

export const ModalSelectCustomItem = ({
  listId,
  root,
  parents,
  handleClose,
  multiple = false,
  selectedItems: defaultItems = [],
  getListItems,
}) => {
  const { translate: t } = useDictionaryTranslation();
  const searchRef = useRef('');
  const [searchValue, setSearchValue] = useState('');
  const [selectedRoot, setSelectedRoot] = useState();
  const [page, setPage] = useState(1);
  const { isLoading, listItems, total, pageSize } = useCustomListItems({
    listId,
    page,
    parents,
    searchValue,
    getListItems,
  });
  const { checkableItems, getSelectedItems, checkItem, uncheckItem, getItemChildren } = useCheckableItems({
    listItems,
    defaultItems,
    multiple,
  });

  const selectItem = (item) => {
    if (!item.checked) {
      checkItem(item);
    } else {
      uncheckItem(item);
    }
  };

  const onClick = (item) => () => {
    if (item.hasChildren) {
      setSelectedRoot(item);
    } else {
      selectItem(item);
    }
  };

  const closeModal = () => {
    handleClose();
  };

  const saveSelection = () => {
    const currentSelectedItems = getSelectedItems();
    handleClose(currentSelectedItems);
  };

  const closeChilds = (selectedChildren) => {
    setSelectedRoot();
    if (selectedChildren == null) return;
    if (selectedChildren.length > 0) {
      checkItem(selectedRoot, selectedChildren);
    } else {
      uncheckItem(selectedRoot);
    }
  };

  const onSearch = async () => {
    setPage(1);
    setSearchValue(searchRef.current);
  };

  const onChangeSearch = async (e) => {
    searchRef.current = e.target.value;
    if (e.target.value.length >= 3) {
      onSearch();
    } else {
      setPage(1);
      setSearchValue('');
    }
  };

  return (
    <>
      <Modal
        maskClosable={false}
        title={root.title}
        centered
        width="60%"
        height="70%"
        onCancel={closeModal}
        destroyOnClose
        visible={root != null}
        footer={
          <Space size="large">
            <Pagination
              hideOnSinglePage
              showSizeChanger={false}
              current={page}
              total={total}
              onChange={setPage}
              pageSize={pageSize}
              style={{ padding: 0 }}
            />
            <Button key="submit" htmlType="submit" type="primary" onClick={saveSelection}>
              {t('accept')}
            </Button>
          </Space>
        }
      >
        <FormWrapper>
          <Spin spinning={isLoading}>
            <Input
              style={{ width: '100%' }}
              enterButton
              onChange={onChangeSearch}
              onPressEnter={onSearch}
              suffix={<IconSearch onClick={onSearch} />}
            />
            <ul>
              {checkableItems.map((item) => {
                return (
                  <CustomListItem key={item.id}>
                    <Checkbox key={root.id} onChange={onClick(item)} checked={item.checked}>
                      {item.title}
                    </Checkbox>
                  </CustomListItem>
                );
              })}
            </ul>
          </Spin>
        </FormWrapper>
      </Modal>
      {selectedRoot?.hasChildren ? (
        <ModalSelectCustomItem
          listId={listId}
          root={selectedRoot}
          handleClose={closeChilds}
          parents={[...parents, selectedRoot.id]}
          selectedItems={getItemChildren(selectedRoot.id, selectedRoot.title)}
          multiple={multiple}
        />
      ) : null}
    </>
  );
};

ModalSelectCustomItem.defaultProps = {
  getListItems: CustomListsService.getListItems,
};

ModalSelectCustomItem.propTypes = {
  multiple: PropTypes.bool,
  listId: PropTypes.string,
  selectedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      nodes: PropTypes.array,
    }),
  ),
  handleClose: PropTypes.func,
  parents: PropTypes.arrayOf(PropTypes.string),
  root: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }),
  getListItems: PropTypes.func,
};
